import { FC, useState } from 'react'
import { Typography, Button, Grid, Tooltip } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import AddStaff from './AddStaff'
import { Search } from '../../../components'
import { useCtrlN, getCtrlNShortcutLabel } from '../../../hooks'

export interface StaffsHeaderProps {
  onClose?: () => void
}

export const StaffsHeader: FC<StaffsHeaderProps> = ({ onClose }) => {
  const [showAddStaff, setShowAddStaff] = useState<boolean>(false)
  const [open, setOpen] = useState(false)
  useCtrlN(() => setShowAddStaff(true))
  return (
    <>
      <Grid container alignItems="flex-end">
        <Grid item xs>
          <Typography variant="h3" component="h3">
            User Management
          </Typography>
        </Grid>
        <Grid item sx={{ width: '30%' }}></Grid>
        <Grid item sx={{ width: 190, textAlign: 'right' }}>
          <Tooltip title={`Add User (${getCtrlNShortcutLabel()})`} arrow>
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              sx={{ backgroundColor: '#37A239', height: 41.5, width: 180 }}
              onClick={() => setShowAddStaff(true)}
            >
              ADD USER
            </Button>
          </Tooltip>
        </Grid>
      </Grid>
      {showAddStaff && (
        <AddStaff
          onClose={() => {
            setShowAddStaff(false)
          }}
        />
      )}
    </>
  )
}

export default StaffsHeader
